import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import { find, cloneDeep, get, capitalize, map, isEqual } from 'lodash';
import config from '../../config/config'
import store from '../../helpers/store'
import { sessionStore } from '../../helpers/SessionStore'
import ReactSelect from '../../components/common/ReactSelect';
import Spinner from '../../components/common/Spinner';
import TopTracks from '../../components/pages/spotifyDiscovery/TopTracks';
import BarChart from '../../components/pages/spotifyDiscovery/BarChart';
import PreviousPeriod from '../../components/pages/spotifyDiscovery/PreviousPeriod';
import MetricChart from '../../components/pages/spotifyDiscovery/MetricChart';
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import SearchWidget from '../../components/pages/home/SearchWidget';
import {Widget, WithWidgetManager, HiddenElements} from '../../components/widgets/manager';
import SharePage from '../../components/pages/sharedPages/SharePage';
import { pdf as PDFRenderer }from '@react-pdf/renderer';
import CSV from '../../helpers/CSVExport';
import PDFDocument from '../../components/pages/spotifyDiscovery/PDF';
import { artistsActions } from '../../data/actions/artists';
import { milestonesActions } from '../../data/actions/milestones';
import { spotifyDiscoveryActions } from '../../data/actions/spotify_discovery';
const downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');
const plusSvg = require('!svg-inline-loader!../../../public/img/plus.svg');

class SpotifyDiscoveryList extends React.Component {

	rangeOptions = [
		{label: 'Group by Week', value: 'clwk'},
		{label: 'Group by Month', value: 'mth'}
	];
	
	constructor(props){
		super(props);
		const { match } = props; 
		let { range = this.rangeOptions[0].value, track_artists = '', discovery_streams = 'false' } = match.params;
		track_artists = track_artists ? track_artists.split(',') : [];
		discovery_streams = Boolean(discovery_streams && discovery_streams == 'true');
		
		this.state = {
			artists: [],
			track_artists,
			range,
			discovery_streams
		}
		this.persistState = this.persistState.bind(this);
		this.toggleDiscoveryStreams = this.toggleDiscoveryStreams.bind(this);
	}
	
	persistState(){
		sessionStore.set('spotifyDiscoveryList', this.state);
	}    
	
	toggleDiscoveryStreams(e){
		this.setState({
			discovery_streams: e.target.checked
		}, ()=>{
			this.props.history.push(`/spotify-discovery/overview/${this.state.range}/${this.state.discovery_streams}/${this.state.track_artists.join(',')}`);
			this.persistState();
		})

	}
	
	componentDidMount(){
		const { dispatch} = this.props;
		const { track_artists } = this.state;
		const artistIDs = map(track_artists, id=>({id}));
		dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryTimeseries(this.state));	
		
		const dataCall = (artistIDs && artistIDs.length > 0) ? dispatch(artistsActions.getMetadata({data: artistIDs})) : Promise.resolve([]);
		dataCall.then(artists => {
			this.setState({
				artists
			}, this.persistState())
		});
	}
	
	componentWillReceiveProps(nextProps){
		const { dispatch } = this.props; 
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryTimeseries(this.state, false));
			}                
		}
		
		if(nextProps.match.params && !isEqual(nextProps.match.params, this.props.match.params)) {
			dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryTimeseries(nextProps.match.params, false));
		} 
		
	}
	
	searchResult = (value) => {
		this.setState({
			artists: [
				...this.state.artists,
				value
			],
			track_artists: [
				...this.state.track_artists,
				value.id
			]
		}, ()=>{
			//this.props.dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryTimeseries(this.state));
			this.props.history.push(`/spotify-discovery/overview/${this.state.range}/${this.state.discovery_streams}/${this.state.track_artists.join(',')}`);
			this.persistState();
		})
	}
	
	removeSearchResult = (id) => {
		let artists = [...this.state.artists.filter(artist=>artist.id !== id)];
		let track_artists = [...this.state.track_artists.filter(artist=>artist !== id)];
		this.setState({
			artists, 
			track_artists
		}, ()=>{
			this.persistState();
			this.props.history.push(`/spotify-discovery/overview/${this.state.range}/${this.state.discovery_streams}/${this.state.track_artists.join(',')}`)
		});
	}
	
	setRange = (range) => {
		this.setState({
			range: range.value
		}, ()=>{
			//this.props.dispatch(spotifyDiscoveryActions.getSpotifyDiscoveryTimeseries(this.state));
			this.persistState();
			this.props.history.push(`/spotify-discovery/overview/${this.state.range}/${this.state.discovery_streams}/${this.state.track_artists.join(',')}`)
		});
	}

	exportToXls = () => {
		const metrics = get(this.props, `spotifyDiscovery.timeseries`, {});
		let metricData = [];
		for(let day in metrics.labels) {
			let row = {'Period': metrics.labels[day]};
			for(let metric of metrics.datasets) {
				row[metric.label] = metric.data[day];
			}
			metricData.push(row);
		}
		const data = [
			{'spotify_discovery_sources': metricData},
			{'spotify_discovery_previous': get(this.props, `spotifyDiscovery.totals`, [])},
			{'spotify_discovery_top_tracks': get(this.props, `spotifyDiscovery.data`)}
		];
		const filename = `spotify_discovery`;
		CSV.CSVBulkExport(data, filename);
	}	
	
	getPdfData() {
		const reportTitle = `Spotify Discovery`,
			{ spotifyDiscovery } = this.props;
			
		const imageIDs = [
			  'spotify_discovery_radio_collection',
			  'spotify_discovery_metrics_radio',
			  'spotify_discovery_metrics_collection',
			  'spotify_discovery_metrics_artist',
			  'spotify_discovery_metrics_search',
			  'spotify_discovery_metrics_discovery',
			  'spotify_discovery_top_tracks'
		];
		let images = {};
		for (let imageID of imageIDs){
			let image = document.getElementById(imageID);
			if(image)
				images[imageID] = image.toDataURL("image/jpeg,1.0"); 
		}
		
		const tables = {
			spotify_discovery_previous: get(this.props, `spotifyDiscovery.totals`),
			spotify_discovery_top_tracks: get(this.props, `spotifyDiscovery.data`)
		};
		return { reportTitle, images, tables };
	}

	exportToPdf = () => {
		const PDFWithManager = WithWidgetManager(PDFDocument, `spotify_discovery_list`);
		const data = PDFRenderer(<PDFWithManager data={this.getPdfData()} />);
		data.toBlob()
		.then(blob=>{
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = fileURL;
			link.download = `spotify_discovery.pdf`;
			link.click();
		});
	}

	renderSelectedArtists = () => {
		const { artists } = this.state;
		return <div className={`page-filter artists`}>
			<div className="tag-list">
		
				<div className="page-filter-list">
					{artists.map(artist=><div key={artist.id} className="tag">
						<div className="tag-name-holder">
							<div className="tag-name">
								<span>{artist.name}</span>
							</div>
							<a
								className="close-link"
								onClick={()=>this.removeSearchResult(artist.id)}
							>
								&times;
							</a>
						</div>
					</div>)}
				</div>

			</div>
		</div>
		
	}


	
	render() {
		const { widgetProps, sharedMode } = this.props;
		const { timeseries = {}, loadingTimeseries } = this.props.spotifyDiscovery;
		const { track_artists, range, discovery_streams } = this.state;
		const rangeValue = find(this.rangeOptions, o=>o.value == range);
		const scorecardState = sessionStore.get('spotifyDiscoveryScorecard');
		const scorecardId = get(scorecardState, 'id', null);

		return <div className="inner-page result-page discovery-page"> 
			<div className="inner-page">
				<div className="spotify-discovery-header">
					<h1 className="spotify-discovery-header-title">
						Spotify Discovery Mode
					</h1>
					<ul className="profile-navigation">
						<NavLink className="profile-navigation-link" to={`/spotify-discovery/overview`}>Overview</NavLink>
						<NavLink className="profile-navigation-link" to={`/spotify-discovery/scorecard/${scorecardId?scorecardId:''}`}>Scorecard</NavLink>
					</ul>
					<div>
						{!sharedMode && <SharePage module="spotify_discovery" entity="overview" id={range} params={track_artists.join(',')} exportToCsv={() => this.exportToXls()} exportToPdf={() => this.exportToPdf()} />}              
						{sharedMode && <a key="download" onClick={() => this.exportToXls()} title="Export CSV" className="download-link download-link-shared-heartbeats" dangerouslySetInnerHTML={{__html: downloadSvg}} />}
					</div>
					<div>
						<Link to="/milestones/spotify-discovery">
							<button type="button" className="default-btn default-btn--small button-icon default-btn--light">
								Add Tracks with Milestones
								<span className="chart-icon chart-icon--small" dangerouslySetInnerHTML={{__html: plusSvg}}></span>
							</button>	
						</Link>
					</div>
				</div>
				<div className="discovery-filter-holder">
					<div className="discovery-filter-row">
						<div className="discovery-filter-item discovery-filter-item-search">
							<SearchWidget searchResult={this.searchResult} placeholder="Filter by artists" entities={['artists']} mode="milestone" />
						</div>
						<div className="discovery-filter-item discovery-filter-item-range">
							<ReactSelect value={rangeValue} options={this.rangeOptions} onChange={this.setRange} className="single-select"/>
						</div>
						<div className="discovery-filter-item discovery-filter-item-range">
							<span>DM Context:
							<div className="checkbox-holder checkbox-holder--block checkbox-switcher-holder user-save-filter">
							   <input type="checkbox" id={`dm_context`} checked={discovery_streams} onChange={this.toggleDiscoveryStreams} className="input" />
							   <label htmlFor={`dm_context`} className="checkbox-label checkbox-switcher"></label>
						   </div>
						   </span>
						</div>
					</div>
					<div className="discovery-filter-row">
						<div className="discovery-filter-item discovery-filter-item-artists">
							{this.renderSelectedArtists()}
						</div>
					</div>
				</div>

				<div className="discovery-overview-main-holder">
					<div className="discovery-overview-widget">
						<Widget widgetID="previous_period" widgetProps={widgetProps}>
							<PreviousPeriod params={this.state} />
						</Widget>
					</div>
						
					<div className="widget-row widget-row--full-width radio-collection-stream-block">
						<Widget widgetID="radio_collection" widgetProps={widgetProps}>
							<BarChart
								data={timeseries}
								loading={loadingTimeseries}
								title="Spotify Radio and Collection Streams"
								period={rangeValue.value}
							/>

						</Widget>
					</div>
				</div>


				<div className="widget-row widget-row--full-width">
					<Widget widgetID="top_tracks" widgetProps={widgetProps}>
						<TopTracks params={this.state} period={rangeValue.value} />
					</Widget>
				</div>
				<div className="widget-row widget-row--full-width">
					<Widget widgetID="chart_radio" widgetProps={widgetProps}>
						<MetricChart
							metric="Radio"
							data={timeseries}
							loading={loadingTimeseries}
							title="Spotify Radio Streams"
							shadowChartWidth={800} 
							period={rangeValue.value}
						/>
					</Widget>
				</div>

				
				<div className="widget-row widget-row--half-width">
					<Widget widgetID="chart_collection" widgetProps={widgetProps}>
						<MetricChart
							metric="Collection"
							data={timeseries}
							loading={loadingTimeseries}
							title="Spotify Collection Streams"
							shadowChartWidth={400} 
							period={rangeValue.value}
						/>
					</Widget>
					<Widget widgetID="chart_artist" widgetProps={widgetProps}>
						<MetricChart
							metric="Artist"
							data={timeseries}
							loading={loadingTimeseries}
							title="Spotify Artist Streams"
							shadowChartWidth={400} 
							period={rangeValue.value}
						/>

					</Widget>
				</div>
				<div className="widget-row widget-row--half-width">
					<Widget widgetID="chart_search" widgetProps={widgetProps}>
						<MetricChart
							metric="Search"
							data={timeseries}
							loading={loadingTimeseries}
							title="Spotify Search Streams"
							shadowChartWidth={400} 
							period={rangeValue.value}
						/>
					</Widget>
					<Widget widgetID="chart_discovery" widgetProps={widgetProps}>
						<MetricChart
							metric="Discovery"
							data={timeseries}
							loading={loadingTimeseries}
							title="Spotify Discovery Streams"
							shadowChartWidth={400} 
							period={rangeValue.value}
						/>
				
					</Widget>
				</div>
				
				{/*

				<div className="widget-row widget-row--full-width">
					<Widget widgetID="territories" widgetProps={widgetProps}>                        
					</Widget>
				</div>
				<div className="widget-row widget-row--full-width">
					<Widget widgetID="top_playlists" widgetProps={widgetProps}>
					</Widget>
				</div>
				<div className="widget-row widget-row--full-width">
					<Widget widgetID="top_tracks" widgetProps={widgetProps}>
					</Widget>
				</div>
				<div className="widget-row widget-row--full-width">
					<Widget widgetID="top_imprints" widgetProps={widgetProps}>
					</Widget>
				</div>

				<div className="widget-row widget-row--full-width">
					<Widget widgetID="devices" widgetProps={widgetProps}>
					</Widget>
				</div>
				*/}
				
			</div>
		</div>
	}
}

function mapStateToProps(state) {
	return {
		filter: state.filter,
		milestones: state.milestones,
		spotifyDiscovery: state.spotifyDiscovery 
	} 
}
export default connect(mapStateToProps)(withRouter(WithWidgetManager(SpotifyDiscoveryList, 'spotify_discovery_list')));